import navigationReducers from './navigation-slice';

export default {
  ...navigationReducers,
};

export * from './navigation-slice';
